import { useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

const PROPERTY_TYPES = ["PG", "Hostel", "Flat", "Apartment", "Co-living"];
const BLANK = { name: "", type: "PG", address: "", city: "", total_rooms: 0 };

export function PropertyForm({ onDone, onCancel }) {
  const [form, setForm] = useState(BLANK);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/properties", { ...form, total_rooms: Number(form.total_rooms) });
      toast.success("Property added");
      onDone();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <form onSubmit={submit} className="bg-white border border-slate-200 p-6 grid md:grid-cols-2 gap-4" data-testid="property-form">
      <input required placeholder="Property name" data-testid="prop-name" className="border border-slate-300 px-4 py-2.5"
             value={form.name} onChange={set("name")} />
      <select className="border border-slate-300 px-4 py-2.5" value={form.type} data-testid="prop-type" onChange={set("type")}>
        {PROPERTY_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
      </select>
      <input required placeholder="Address" data-testid="prop-address" className="border border-slate-300 px-4 py-2.5 md:col-span-2"
             value={form.address} onChange={set("address")} />
      <input required placeholder="City" data-testid="prop-city" className="border border-slate-300 px-4 py-2.5"
             value={form.city} onChange={set("city")} />
      <input type="number" min="0" placeholder="Total rooms" data-testid="prop-totalrooms" className="border border-slate-300 px-4 py-2.5"
             value={form.total_rooms} onChange={set("total_rooms")} />
      <div className="md:col-span-2 flex gap-3">
        <button data-testid="prop-save" className="bg-slate-900 text-white px-6 py-2.5">Save</button>
        <button type="button" onClick={onCancel} className="bg-slate-100 px-6 py-2.5">Cancel</button>
      </div>
    </form>
  );
}
